import { Col, Divider, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { AppraisalSectionViewProps } from ".";
import { AMOUNT_UTIL } from "../../../../../../utils/amount.utils";

const Calculations = (props: AppraisalSectionViewProps) => {

    const { t } = useTranslation();

    return (
        <div className="section-wrapper">
            <p className="description">{t("Appraisal.CalculationsDes")}</p>
            <Row gutter={[16, 32]} className="row-space">
                <Col span={12}>
                    <b>{t("Appraisal.lbNetCashInflow")}</b>
                    <span className="blue-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.annual_total)}
                    </span>
                </Col>
                <Col span={12}>
                    <b>{t("Appraisal.lbNetCashOutflow")}</b>
                    <span className="red-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_outflow?.annual_total)}
                    </span>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Appraisal.lbDiscount")}
                    >
                        <span>
                            {AMOUNT_UTIL.converNumberToPercentage(props.data?.percentage_discount_rate_used_in_npv)}
                        </span>
                    </Form.Item>
                </Col>
            </Row>

            <div className="caculation-table">
                <Row className="t-header">
                    < Col>
                    </Col>
                    < Col>
                        {t("Appraisal.lbYear1")}
                    </Col>
                    < Col>
                        {t("Appraisal.lbYear2")}
                    </Col>
                    < Col>
                        {t("Appraisal.lbYear3")}
                    </Col>
                    < Col>
                        {t("Appraisal.lbYear4")}
                    </Col>
                    < Col>
                        {t("Appraisal.lbYear5")}
                    </Col>
                </Row>
                <Row gutter={10}>
                    < Col>
                        {t("Appraisal.lbPercentage")}
                    </Col>
                    < Col>
                        {AMOUNT_UTIL.converNumberToPercentage(props.data?.percentage_of_benefits_realized?.year_1)}
                    </Col>
                    < Col>
                        {AMOUNT_UTIL.converNumberToPercentage(props.data?.percentage_of_benefits_realized?.year_2)}
                    </Col>
                    < Col>
                        {AMOUNT_UTIL.converNumberToPercentage(props.data?.percentage_of_benefits_realized?.year_3)}
                    </Col>
                    < Col>
                        {AMOUNT_UTIL.converNumberToPercentage(props.data?.percentage_of_benefits_realized?.year_4)}
                    </Col>
                    < Col>
                        <span>{AMOUNT_UTIL.converNumberToPercentage(props.data?.percentage_of_benefits_realized?.year_5)}</span>
                    </Col>
                </Row>
                <Row>
                    < Col>
                        {t("Appraisal.lbInflowAmount")}
                    </Col>
                    < Col className="green-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_1)}
                    </Col>
                    < Col className="green-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_2)}
                    </Col>
                    < Col className="green-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_3)}
                    </Col>
                    < Col className="green-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_4)}
                    </Col>
                    < Col className="green-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_5)}
                    </Col>
                </Row>
                <Row>
                    < Col>
                        {t("Appraisal.lbOutflowAmount")}
                    </Col>
                    < Col className="red-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_outflow?.year_1)}
                    </Col>
                    < Col className="red-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_outflow?.year_2)}
                    </Col>
                    < Col className="red-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_outflow?.year_3)}
                    </Col>
                    < Col className="red-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_outflow?.year_4)}
                    </Col>
                    < Col className="red-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_outflow?.year_5)}
                    </Col>
                </Row>

                <Divider />

                <Row className="footer-row">
                    < Col>
                        {t("Appraisal.lbNetAnnual")}
                    </Col>
                    < Col>
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_1)}
                    </Col>
                    < Col>
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_2)}
                    </Col>
                    < Col>
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_3)}
                    </Col>
                    < Col>
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_4)}
                    </Col>
                    < Col>
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_5)}
                    </Col>
                </Row>
                <Row className="footer-row">
                    < Col>
                        {t("Appraisal.lbRemaining")}
                    </Col>
                    < Col className="green-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_1)}
                    </Col>
                    < Col className="green-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_2)}
                    </Col>
                    < Col className="green-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_3)}
                    </Col>
                    < Col className="green-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_4)}
                    </Col>
                    < Col className="green-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_cash_inflow?.year_5)}
                    </Col>
                </Row>

            </div>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Appraisal.lbInternalRate")}
                    >
                        <span>{AMOUNT_UTIL.converNumberToPercentage(props.data?.internal_rate_of_return)}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Appraisal.lbPaybackPeriod")}
                    >
                        <span>{props.data?.payback_period}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Appraisal.lbNetPresentValue")}
                    >
                        <span>{AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.net_present_value)}</span>
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default Calculations;